import { SiteUrls } from '@tableau/shared-urls/lib/src/SharedUrls';
import * as React from 'react';

import { InterpolatedString } from '../../../common/react/components/InterpolatedString';
import { IReactTranslateService } from '../../../common/react/IReactTranslateService';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { DeprecatedReactPlacePageActionsMenu } from '../PlacePageActionsMenu';
import { SpotlightActionList } from '../SpotlightActionList';

export type ContentPlaceHeaderProps = {
  readonly contentTypeName: string;
  readonly siteUrls: SiteUrls;
  readonly translate: IReactTranslateService;
  readonly descriptionLineParts: ReadonlyArray<JSX.Element> | null;
  readonly owner: IUserInfo;
  readonly name: string;
  readonly spotlightActions: ReadonlyArray<SpotlightActionList.SpotlightActionAttributes> | null;
  readonly actionsMenuProps: DeprecatedReactPlacePageActionsMenu.Props<any, any> | null;
  readonly contentIcon: string;
};

export enum ContentPlaceHeaderIcons {
  flow = 'tb-place-type-icon tb-place-type-icon-flow',
  workbook = 'tb-place-type-icon tb-place-type-icon-workbook',
}

export class ContentPlaceHeader extends React.Component<ContentPlaceHeaderProps> {
  private contentPlaceDescriptionLineSeparator(): JSX.Element {
    return <span className="tb-place-description-line-separator">&bull;</span>;
  }
  private contentPlaceNameLine(): JSX.Element {
    return (
      <div className="tb-place-name-line">
        <div className={this.props.contentIcon}/>
        <div className="tb-place-name tb-workbook-place-name tb-enable-selection tb-margin-right-wide"
          data-tb-test-id="place-name"
          title={this.props.name}>
          {this.props.name}
        </div>
        {this.props.spotlightActions && <SpotlightActionList actions={this.props.spotlightActions} />}
        {this.props.actionsMenuProps && <DeprecatedReactPlacePageActionsMenu {...this.props.actionsMenuProps } />}
      </div>
    );
  }

  private UserByLine(): JSX.Element {
    const userUrl = this.props.siteUrls.userUrl(this.props.owner.username, this.props.owner.domainName);
    const userLink = () => <a href={userUrl}>{this.props.owner.displayName}</a>;

    return <InterpolatedString baseStringKey="placeByLine"
      translate={this.props.translate}
      replacements={{ USER_LINK: userLink }} />;
  }

  private contentPlaceDescriptionLine(): JSX.Element {
    return (
      <div className="tb-place-description-line">
        <span className="tb-place-type-text">{this.props.contentTypeName}</span>
        {this.contentPlaceDescriptionLineSeparator()}
        <span className="tb-place-description-line-owner">
          {this.UserByLine()}
        </span>
        {this.props.descriptionLineParts && this.props.descriptionLineParts.map(
          (element, index) => (
            <span key={index}>
              {this.contentPlaceDescriptionLineSeparator()}
              {element}
            </span>)
        )}
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <div className="tb-place-information">
        <div className="tb-place-name-and-description">
          {this.contentPlaceNameLine()}
          {this.contentPlaceDescriptionLine()}
        </div>
      </div>
    );
  }
}
